
// The single cell editor. Exactly one instance exists at a time - it is mounted into the
// selected cell and unmounted when editing ends - so the grid never pays per-cell component
// cost. It edits the cell's raw string; decoding back to a value happens at save time.
export default {
	name: 'SpreadsheetCellEditor',
	props: {
		value: { type: String, default: '' },
		multiline: { type: Boolean, default: false },
	},
	data() {
		return {
			draft: this.value,
			done: false, // guard so blur after an explicit commit/cancel doesn't fire twice
		}
	},
	methods: {
		commit(move: boolean) {
			if (this.done) return
			this.done = true
			this.$emit('commit', { value: this.draft, move })
		},
		cancel() {
			if (this.done) return
			this.done = true
			this.$emit('cancel')
		},
	},
	mounted() {
		const input = this.$refs.input as HTMLInputElement | HTMLTextAreaElement
		input?.focus()
		input?.select?.()
	},
}
